var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLocationAccessIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 60,
    height: 60,
    viewBox: "0 0 60 60",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_2740",
    "data-name": "Group 2740",
    transform: "translate(-9317 -2727.001)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_77",
    "data-name": "Ellipse 77",
    cx: 30,
    cy: 30,
    r: 30,
    transform: "translate(9317 2727)",
    fill: "#1b62ab"
  }), /*#__PURE__*/React.createElement("path", {
    id: "noun-user-path-643028",
    d: "M94.387.023a5.632,5.632,0,0,0-5.625,5.625c0,2.849,4.566,10.684,5.086,11.568a.626.626,0,0,0,1.078,0c.521-.884,5.086-8.719,5.086-11.568A5.632,5.632,0,0,0,94.387.023Zm0,8.75a3.125,3.125,0,1,1,3.125-3.125A3.129,3.129,0,0,1,94.387,8.773ZM83.215,25.59a.628.628,0,0,0-.825.319,5.086,5.086,0,0,1-1.23,1.809.625.625,0,0,0,.834.933,6.369,6.369,0,0,0,1.54-2.235.624.624,0,0,0-.319-.825ZM75.637,6.274a3.125,3.125,0,1,0-3.125-3.125A3.125,3.125,0,0,0,75.637,6.274Zm5.61,11.545-.827-7.26a3.308,3.308,0,0,0-3.186-3.036.626.626,0,0,0-.573.375L75.61,10.3l-.991-2.394a.625.625,0,0,0-.578-.386,3.307,3.307,0,0,0-3.186,3.036l-.827,7.26a2.112,2.112,0,0,0,.514,1.653,1.843,1.843,0,0,0,1.284.631l.69,9.341a.625.625,0,0,0,.624.579h5a.626.626,0,0,0,.624-.579l.69-9.341a1.85,1.85,0,0,0,1.284-.631,2.116,2.116,0,0,0,.511-1.651Zm3.539,3.08a.622.622,0,0,0-.811.349c-.3.742-.529,1.513-.754,2.256l-.042.143a.624.624,0,0,0,.417.779.6.6,0,0,0,.181.026.626.626,0,0,0,.6-.444l.042-.141c.217-.72.443-1.463.719-2.156a.626.626,0,0,0-.351-.811Zm6.445-4.625a12.637,12.637,0,0,0-1.311.132.625.625,0,0,0,.1,1.243.638.638,0,0,0,.1-.008,10.9,10.9,0,0,1,1.18-.119.625.625,0,1,0-.063-1.249Zm-3.88.94a6.332,6.332,0,0,0-2.091,1.724.626.626,0,0,0,.98.777,5.109,5.109,0,0,1,1.688-1.391.625.625,0,1,0-.577-1.11Z",
    transform: "translate(9263.987 2742.052)",
    fill: "#fff"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLocationAccessIcon);
export default __webpack_public_path__ + "static/media/location-access-icon.6638a0f4.svg";
export { ForwardRef as ReactComponent };